import createApolloClient from '@/plugins/apollo/config/createApolloClient';

export enum FETCH_POLICY {
  CACHE_FIRST = 'cache-first',
  CACHE_AND_NETWORK = 'cache-and-network',
  NETWORK_ONLY = 'network-only',
  NO_CACHE = 'no-cache',
  STANDBY = 'standby',
}

const builderApolloClient = createApolloClient({
  // @ts-ignore
  httpEndpoint: `https://cdn.builder.io/api/v3/graphql/${process.env.BUILDERIO}`,
  httpOptions: {
    headers: { 'keep-alive': 'true' },
    credentials: 'same-origin',
  },
  retryOptions: {
    delay: {
      initial: process.env.GQL_RETRY_DELAY_INTIAL,
      max: process.env.GQL_DELAY_MAX,
    },
    attempts: {
      max: '1',
    },
  },
  timeout: process.env.GQL_TIMEOUT,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: FETCH_POLICY.CACHE_AND_NETWORK,
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: FETCH_POLICY.NETWORK_ONLY,
      errorPolicy: 'all',
      partialRefetch: true,
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});

export default builderApolloClient;
